var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-form",
    {
      ref: "form",
      attrs: { "lazy-validation": "" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
      model: {
        value: _vm.valid,
        callback: function ($$v) {
          _vm.valid = $$v
        },
        expression: "valid",
      },
    },
    [
      _c(
        "v-container",
        { staticClass: "text-center" },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      "data-cy": "FormPreferredDeliveryAddress-customerId",
                      filled: "",
                      label: _vm.$$t("customerCode"),
                      "item-text": "customerDesc",
                      "item-value": "customerId",
                      items: _vm.customers,
                    },
                    on: { change: _vm.customerChanged },
                    model: {
                      value: _vm.localPreferredDeliveryAddress.customerId,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.localPreferredDeliveryAddress,
                          "customerId",
                          $$v
                        )
                      },
                      expression: "localPreferredDeliveryAddress.customerId",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("v-select", {
                    attrs: {
                      "data-cy":
                        "FormPreferredDeliveryAddress-deliveryAddressId",
                      filled: "",
                      label: _vm.$$t("deliveryAddress"),
                      items: _vm.deliveryAddresses,
                      "item-text": "delAddress01",
                      "item-value": "id",
                      loading: _vm.loadingDeliveryAddresses,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item",
                        fn: function ({ item }) {
                          return [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "min-height": "50px",
                                  "margin-bottom": "15px",
                                  width: "100%",
                                },
                              },
                              [
                                _c("p", [_vm._v(_vm._s(item.delAddress01))]),
                                _c("p", [_vm._v(_vm._s(item.delAddress02))]),
                                _c("p", [_vm._v(_vm._s(item.delAddress03))]),
                                _c("v-divider"),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                    model: {
                      value:
                        _vm.localPreferredDeliveryAddress.deliveryAddressId,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.localPreferredDeliveryAddress,
                          "deliveryAddressId",
                          $$v
                        )
                      },
                      expression:
                        "localPreferredDeliveryAddress.deliveryAddressId",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      items: _vm.users,
                      "item-text": "username",
                      "item-value": "username",
                      filled: "",
                      "data-cy": "FormPreferredDeliveryAddress-username",
                      label: _vm.$$t("username"),
                    },
                    model: {
                      value: _vm.localPreferredDeliveryAddress.username,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.localPreferredDeliveryAddress,
                          "username",
                          $$v
                        )
                      },
                      expression: "localPreferredDeliveryAddress.username",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "d-flex justify-end mb-6" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "ml-4 btn-cancel",
                  attrs: {
                    color: "default",
                    outlined: "",
                    "data-cy": "FormPreferredDeliveryAddress-button-cancel",
                  },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.buttons.cancel")) + " ")]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "ml-4",
                  attrs: {
                    color: "primary",
                    type: "submit",
                    loading: _vm.isSaving,
                    "data-cy": "FormPreferredDeliveryAddress-button-save",
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.buttons.save")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }